import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { FAQ } from "@/data/citta";

export function Faq() {
  return (
    <section id="faq" className="border-y border-slate-800 bg-abyss py-24 md:py-32">
      <div className="mx-auto max-w-4xl px-5 md:px-8">
        <Reveal className="text-center">
          <p className="overline-label">Domande frequenti</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Tutto quello che devi sapere
          </h2>
        </Reveal>

        <Reveal delay={0.15} className="mt-12">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQ.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-slate-800"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display text-base font-semibold text-white hover:text-amber-400 sm:text-lg">
                  {f.domanda}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-slate-400 sm:text-base">
                  {f.risposta}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
